"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_SplitDamageReflectEventHandlerScript = void 0;
const Damage_1 = require("../../core/Damage");
const DamageType_1 = require("../../core/enums/DamageType");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_SplitDamageReflectEventHandlerScript = class Effect_SplitDamageReflectEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Damaged) {
            return;
        }
        const reflectAmount = Math.round(event.args.damage.amount / handler.args.scriptArgs.enemies.length);
        for (const enemy of handler.args.scriptArgs.enemies) {
            container.applyExactDamage({
                sequence,
                attackerId: handler.args.scriptArgs.originalCreatorId,
                targetId: enemy,
                damage: new Damage_1.Damage(DamageType_1.DamageType.Chaos, reflectAmount)
            });
        }
    }
};
Effect_SplitDamageReflectEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_SplitDamageReflect")
], Effect_SplitDamageReflectEventHandlerScript);
exports.Effect_SplitDamageReflectEventHandlerScript = Effect_SplitDamageReflectEventHandlerScript;
